/**
 * Files chosen in a slot and not uploaded yet (D37).
 *
 * A picture reaches the door only through its upload; a save sends the ids of the files the
 * door already holds. The configurator keeps every chosen file here, by its slot, and the next
 * save uploads them first (21.10.2026).
 *
 * Held by the configurator rather than by each slot: only the chosen step's slots are on the
 * screen, and a file chosen on slide 2 has to survive a look at the quiz.
 */
export const EMPTY_SLOT = { file: null, altText: "", crop: null };
/** The key of a slot in the form: its kind and its row. */
export function slotKey(target) {
    return target.kind === "prize" ? "prize" : `${target.kind}:${target.key}`;
}
/**
 * The chosen files in the order of the door: slides first, then the quiz, then the prize. A
 * file chosen for a row that was removed since has no slot any more and is left out.
 */
export function pendingFiles(drafts, order) {
    const rank = (pick) => pick.target.kind === "prize"
        ? order.length
        : order.findIndex((row) => pick.target.kind !== "prize" && row.key === pick.target.key);
    const picked = [];
    for (const { target, file, altText, crop } of Object.values(drafts)) {
        if (file !== null) {
            picked.push({ target, file, altText, crop });
        }
    }
    return picked
        .filter((pick) => rank(pick) >= 0)
        .sort((left, right) => rank(left) - rank(right));
}
//# sourceMappingURL=pending.js.map